import React, { useState } from 'react'
import wideview from '../../../Assets/Images/wideView.svg'
import Likert from '../../Charts/Likert/Likert'
import SentimentsRadar from './SentimentsRadar';
import { surveys } from '../../../utils/surveys';
export default function Sentiments({ setTableViewOpen }) {
  const left_labels = [
    {
      label: 0,
      color: '#E0510D'
    },
    {
      label: 1,
      color: '#F48956'
    },
    {
      label: 2,
      color: '#F8C9B4'
    }
  ];
  const right_labels = [
    {
      label: 3,
      color: '#DDEBA9'
    },
    {
      label: 4,
      color: '#ACC549'
    },
    {
      label: 5,
      color: '#7D8704'
    }
  ];
  const responses = {
    total: 100,
    data: {
      0: 10,
      1: 7,
      2: 50,
      3: 11,
      4: 11,
      5: 11
    }
  }
  const [average, setAverage] = useState(0.4);
  const getAverageColor = (average) => {
    switch (Math.floor(average)) {
      case 0: return {
        background: "#E0510D",
        color: "#ffffff"
      }
      case 1: return {
        background: "#F48956",
        color: "#000000"
      }
      case 2: return {
        background: "#F8C9B4",
        color: "#000000"
      }
      case 3: return {
        background: "#DDEBA9",
        color: "#000000"
      }
      case 4: return {
        background: "#ACC549",
        color: "#ffffff"
      }
      case 5: return {
        background: "#7D8704",
        color: "#ffffff"
      }
    }
  }

  const mapSentiments = (surveys) => {
    const sentimentIds = ['2.1', '2.2', '2.3', '2.4', '2.5'];
    const sentimentHeadings = ['SATISFACTION', 'SERVES OTHERS', 'SERVES GOD', 'POSITIVE EFFECT ON THE WORLD', 'COMFORT IDENTIFYING AS CHRISTIAN'];
    const sentimentsSubHeadings = ['I am satisfied with my work', 'I clearly see how my work serves others', 'I clearly see how my work serves God', 'I believe my work has a positive effect on the world', 'I feel comfortable identifying as a Christian']
  
    return sentimentIds.map((id, index) => {
      const data = { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
      
      surveys.forEach(survey => {
        if (survey.sentiments && survey.sentiments.rating[id] !== undefined) {
          const rating = Math.floor(survey.sentiments.rating[id]);
          data[rating] += 1;
        }
      });
      
      const totalResponses = Object.values(data).reduce((acc, count) => acc + count, 0);
      const average = (Object.entries(data).reduce((acc, [score, count]) => acc + (score * count), 0) / totalResponses).toFixed(1);
      
      return {
        id: `#${id}`,
        heading: sentimentHeadings[index],
        sub_heading: sentimentsSubHeadings[index],
        responses: {
          total: totalResponses,
          data
        },
        average
      };
    });
  };

  const mapPractices = (surveys) => {
    const practicesIds = ['3.1', '3.2', '3.3', '3.4'];
    const practiceHeadings = ['PRAYED ABOUT WORK', 'CONSIDERED FAITH', 'OPENLY EXPRESSED FAITH', 'CHRISTIAN COMMUNITY AT WORK'];
    const practiceSubheadings = ['I have prayed about my work', 'I’ve considered my faith when making decisions at work', "I've openly expressed my faith at work", 'I’ve met with other Christians at work to talk about faith']
  
    return practicesIds.map((id, index) => {
      const data = { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
      
      surveys.forEach(survey => {
        if (survey.practices && survey.practices.rating[id] !== undefined) {
          const rating = Math.floor(survey.practices.rating[id]);
          data[rating] += 1;
        }
      });
      
      const totalResponses = Object.values(data).reduce((acc, count) => acc + count, 0);
      const average = (Object.entries(data).reduce((acc, [score, count]) => acc + (score * count), 0) / totalResponses).toFixed(1);
      
      return {
        id: `#${id}`,
        heading: practiceHeadings[index],
        sub_heading: practiceSubheadings[index],
        responses: {
          total: totalResponses,
          data
        },
        average
      };
    });
  };

  const sentiments = mapSentiments(surveys);
  const practices = mapPractices(surveys);
  
  return (
    <div className='sentiments-container'>
      <div className="flex-container">
        <div className='sentiments-card'>
          <div className="table-head">
            <div className="heading">Sentiments</div>
            <div className="likert-head">
              <div className='text'>DISAGREE</div>
              {
                left_labels.map(label => <div className='label'>
                  <div className="color-box" style={{ backgroundColor: label.color }}></div>
                  <div className="label-name">{label.label}</div>
                </div>)
              }
              {
                right_labels.map(label => <div className='label'>
                  <div className="color-box" style={{ backgroundColor: label.color }}></div>
                  <div className="label-name">{label.label}</div>
                </div>)
              }
              <div className='text'>AGREE</div>
            </div>
            <div className="extra"></div>
          </div>
          {
            sentiments.map((sentiment, i) =>
              <div className="row" key={i}>
                <div className="serial-no">{sentiment.id}</div>
                <div className="text">
                  <div className="heading">{sentiment.heading}</div>
                  <div className="sub-heading">{sentiment.sub_heading}</div>
                </div>
                <div className="likert-column">
                  <Likert left_labels={left_labels} right_labels={right_labels} responses={sentiment.responses} />
                </div>
                <div className="average-rating" style={{ backgroundColor: getAverageColor(sentiment.average).background, color: getAverageColor(sentiment.average).color }}>{sentiment.average}</div>
                <div className="expand" onClick={() => setTableViewOpen(true)}>
                  <img src={wideview} alt="" />
                </div>
              </div>
            )
          }
        </div>
        <SentimentsRadar setTableViewOpen={setTableViewOpen} />
      </div>
      <div className="flex-container">
        <div className='practices-card'>
          <div className="table-head">
            <div className="heading">Practices</div>
            <div className="likert-head">
              <div className='text'>DISAGREE</div>
              {
                left_labels.map(label => <div className='label'>
                  <div className="color-box" style={{ backgroundColor: label.color }}></div>
                  <div className="label-name">{label.label}</div>
                </div>)
              }
              {
                right_labels.map(label => <div className='label'>
                  <div className="color-box" style={{ backgroundColor: label.color }}></div>
                  <div className="label-name">{label.label}</div>
                </div>)
              }
              <div className='text'>AGREE</div>
            </div>
            <div className="extra"></div>
          </div>
          {
            practices.map((sentiment, i) =>
              <div className="row" key={i}>
                <div className="serial-no">{sentiment.id}</div>
                <div className="text">
                  <div className="heading">{sentiment.heading}</div>
                  <div className="sub-heading">{sentiment.sub_heading}</div>
                </div>
                <div className="likert-column">
                  <Likert left_labels={left_labels} right_labels={right_labels} responses={sentiment.responses} />
                </div>
                <div className="average-rating" style={{ backgroundColor: getAverageColor(sentiment.average).background, color: getAverageColor(sentiment.average).color }}>{sentiment.average}</div>
                <div className="expand" onClick={() => setTableViewOpen(true)}>
                  <img src={wideview} alt="" />
                </div>
              </div>
            )
          }
        </div>
        <SentimentsRadar setTableViewOpen={setTableViewOpen} />
      </div>
    </div>)
}
